import { bool, func } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Label } from 'reactstrap';

import Association from '../../../associations/Association';
import SingleSelect from '../../../generic/SingleSelect';
import { opportunityShape } from '../../../prop-types';
import api from '../../../REST/api';
import { creativePoolOptions } from '../../constants';
import OpportunitySalesUnit from '../OpportunitySalesUnit';

function OpportunityUsers({
  model,
  readOnly,
  onChange,
  isSalesChannelSelfService,
  isSalesChannelManaged,
  isSalesforceOpp,
}) {
  const { ownerId, pc1Id, pc2Id, collaboratorIds, creativePool } = model;
  const inputProps = { onChange, readOnly };
  const selfServiceReadOnly = isSalesChannelSelfService
    ? !onChange
    : inputProps.readOnly;

  const handleOwnerChange = e => {
    if (isSalesChannelSelfService || isSalesChannelManaged) {
      api.getUser({ id: e.target.value }).then(newOwner => {
        onChange(e);
        if (isSalesChannelSelfService)
          onChange({
            target: {
              name: 'pc1Id',
              value: newOwner.id,
            },
          });
        onChange({
          target: {
            name: 'salesUnit',
            value: newOwner.salesUnit,
          },
        });
        onChange({
          target: {
            name: 'salesTeam',
            value: newOwner.salesTeam,
          },
        });
      });
    } else {
      onChange(e);
    }
  };
  return (
    <div className="mb-5">
      <FormGroup row>
        <Label sm={4} for="op-ownerId" className="required">
          Owner
        </Label>
        <Col sm={8}>
          <Association
            id="op-ownerId"
            name="ownerId"
            value={ownerId}
            type="user"
            onChange={handleOwnerChange}
            readOnly={selfServiceReadOnly || isSalesforceOpp}
            showIcon
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={4} for="op-pc1Id">
          PC 1
        </Label>
        <Col sm={8}>
          <Association
            id="op-pc1Id"
            name="pc1Id"
            value={pc1Id}
            type="user"
            {...inputProps}
            readOnly={selfServiceReadOnly || isSalesforceOpp}
            showIcon
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={4} for="op-pc2Id">
          PC 2
        </Label>
        <Col sm={8}>
          <Association
            id="op-pc2Id"
            name="pc2Id"
            value={pc2Id}
            type="user"
            {...inputProps}
            showIcon
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={4} for="op-collaboratorIds">
          Collaborators
        </Label>
        <Col sm={8}>
          <Association
            id="op-collaboratorIds"
            name="collaboratorIds"
            value={collaboratorIds}
            type="user"
            isMulti
            showTeam
            {...inputProps}
          />
        </Col>
      </FormGroup>
      <OpportunitySalesUnit
        opportunity={model}
        onChange={onChange}
        readOnly={selfServiceReadOnly || isSalesforceOpp}
      />
      <FormGroup row>
        <Label sm={4} for="op-creativePool" className="required">
          Creative Team
        </Label>
        <Col sm={8}>
          <SingleSelect
            options={creativePoolOptions}
            id="op-creativePool"
            name="creativePool"
            value={creativePool}
            {...inputProps}
          />
        </Col>
      </FormGroup>
    </div>
  );
}
OpportunityUsers.propTypes = {
  model: opportunityShape.isRequired,
  readOnly: bool,
  onChange: func,
  isSalesChannelSelfService: bool,
  isSalesChannelManaged: bool,
  isSalesforceOpp: bool,
};
OpportunityUsers.defaultProps = {
  readOnly: false,
  onChange: undefined,
  isSalesChannelSelfService: false,
  isSalesChannelManaged: false,
  isSalesforceOpp: false,
};

export default OpportunityUsers;
